import React, { useEffect } from 'react';
import { useAuth } from '@/features/auth/providers/AuthProvider/hooks';
import Preloader from '@/components/Preloader';

const Logout: React.FC = () => {
  const { logout } = useAuth();
  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    (async () => {
      await logout();
      setLoading(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Preloader
      message="Até logo! Estamos encerrando sua sessão."
      loading={loading}
    />
  );
};

export default Logout;
